export enum CostTypeRef {
  // ─── Objets sources "physiques" ──────────────────────────────────────────────
  CALL = 'call', // appel téléphonique
  SMS_OUTBOUND = 'sms-outbound',
  SMS_INBOUND = 'sms-inbound',
  VOICEMAIL = 'voicemail',
  AI_AGENT = 'aiagent',
  AI_AGENT_INBOUND = 'ai-agent-inbound',
  AI_AGENT_OUTBOUND = 'ai-agent-outbound',

  // ─── Opérations OpenAI liées au contact ──────────────────────────────────────
  CONTACT_CLEAN_CIVILITY = 'contact-clean-civility',
  CONTACT_CONTEXT = 'contact-context',
  CONTACT_QUALIFICATION = 'contact-qualification',
  CONTACT_360 = 'contact-360',
  QUALIFICATION_SATISFACTION = 'qualification-satisfaction',
  FOLLOW_UP = 'follow-up',
  AVIV_EXTRACT = 'aviv-extract',
  TAGS_STATUS = 'tags-status',
  TAGS_HEAT = 'tags-heat',
  TAGS_TYPOLOGY = 'tags-typology',
  TAGS_CUSTOM = 'tags-custom', // tags perso `ai_managed`, distincts de la typologie

  // ─── Opérations OpenAI liées à la conversation / SMS ──────────────────────────
  COMPLETIONS = 'completions',
  CONVERSATION_SUMMARY = 'conversation-summary',
  SATISFACTION_SCORE = 'satisfaction-score',
  COMPLAINT_SCORE = 'complaint-score',
  SMS_ANNOTATION = 'sms-annotation',
  ANONYMIZE = 'anonymize',
  AI_CONTACT_INFORMATION_EXTRACTOR_SMS = 'ai-contact-information-extractor-sms',
  AI_TASK_DETECTOR_SMS = 'ai-task-detector-sms',

  // ─── Opérations OpenAI liées à l'appel (transcription / analyse) ──────────────
  TRANSCRIPTION = 'transcription',
  AI_CONTEXTUALIZER = 'ai-contextualizer',
  AI_SPEAKER_IDENTIFIER = 'ai-speaker-identifier',
  AI_NAME_CORRECTOR = 'ai-name-corrector',
  AI_SUMMARIZER = 'ai-summarizer',
  AI_RECEPTIONIST_SUMMARIZER = 'ai-receptionist-summarizer',
  AI_TRANSCRIPTION_SRT = 'ai-transcription-srt', // conversion JSON -> SRT du webhook Callr
  AI_CONTACT_INFORMATION_EXTRACTOR_CALL = 'ai-contact-information-extractor-call',
  AI_TASK_DETECTOR_CALL = 'ai-task-detector-call',
  AI_BUYER_PROFILE_DETECTOR = 'ai-buyer-profile-detector',
  AI_RENTER_PROFILE_DETECTOR = 'ai-renter-profile-detector',
  CALL_RECEPTIONIST = 'call-receptionist',

  // ─── Opérations OpenAI liées au scénario ──────────────────────────────────────
  SCENARIO_NAME = 'scenario-name',
  SCENARIO_ENHANCE = 'scenario-enhance',

  // ─── Opérations OpenAI liées à l'email ────────────────────────────────────────
  EMAIL_CONTACT = 'email-contact',
  MAIL_SUBJECT = 'mail-subject',

  // ─── Tâches ───────────────────────────────────────────────────────────────────
  TASK_SIMILAR = 'task-similar',
  AI_TASK_DICTATION = 'ai-task-dictation',

  // ─── Divers ───────────────────────────────────────────────────────────────────
  DEMO_DATASET = 'demo-dataset',
  CREDITS_RENEWAL = 'credits-renewal', // Renouvellement mensuel des leedbucks (crédit ajouté, credit_consumed négatif)
  PROMOTIONAL_CREDITS_RENEWAL = 'promotional-credits-renewal', // Renouvellement pendant une promotion de crédits de l'abonnement (`leedbucks_credits_temp`), même sens que CREDITS_RENEWAL
  CREDITS_ADJUSTMENT = 'credits-adjustment', // Ajustement manuel du back-office (credit_consumed = -delta, raison dans `model`)
}
